import { Component, OnInit, Input, SimpleChanges, ViewChild } from '@angular/core';
/*App imports*/
import { HelpersService, EstatusCreditos, TiposCreditos } from '../../../services/tools/helpers.service';
import { PagosService } from '../../../services/pagos.service';
import { AgregarPagoComponent } from './components/agregar-pago/agregar-pago.component';
import { CreditosService } from '../../../services/creditos.service';
import { AutenticacionService } from '../../../services/autenticacion.service';

@Component({
  selector: 'tabla-pagos',
  templateUrl: './tabla-pagos.component.html'
})
export class TablaPagosComponent implements OnInit {
  @Input() public idCreditos: number = null;
  @ViewChild('agregarPago') agregarPago: AgregarPagoComponent;

  public tablaPagos: any[] = [];
  public subPagos: any[] = [];
  public subpagosPorPago: { [idPago: number]: any[] } = {};
  public expandedPagos: { [idPago: number]: boolean } = {};
  public errors: any = {};
  public isValidShowPagos: boolean = false;
  public isValidToAddPago: boolean = false;
  public isCreditoMeses: boolean = false;
  public isExecutive: boolean = false;
  public waitingResponse: boolean = false;
  public loadingSubPagos: { [idPago: number]: boolean } = {};

  constructor(
    private helperService: HelpersService,
    private pagosService: PagosService,
    private creditosService: CreditosService,
    private autenticacionService: AutenticacionService
  ) { }

  ngOnInit() {
    this.isExecutive = this.autenticacionService.isExecutive();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.idCreditos && this.idCreditos) {
      this.reloadTablaPagos();
    }
  }

  public reloadTablaPagos() {
    this.getCredito(this.idCreditos);
    this.getTablaPagos(this.idCreditos);
    this.subpagosPorPago = {};
    this.expandedPagos = {};
    this.loadingSubPagos = {};
  }

  private getTablaPagos(idCredito: number) {
    this.pagosService.getTablaPagos(idCredito).subscribe(
      response => {
        let jsonResponse = response && response.json ? response.json() : null;
        let rawData = (jsonResponse && jsonResponse.content) ? jsonResponse.content : [];

        console.log("⚠️ Datos crudos recibidos:", rawData);

        this.tablaPagos = rawData.filter(pago => pago && pago.idPago !== undefined && pago.idPago !== null);

        console.log("✅ Tabla de pagos filtrada:", this.tablaPagos);
      },
      error => {
        this.helperService.httpGlobalError(error);
        if (error.status == 400) {
          let errorContent = error.json ? error.json().content : null;
          this.helperService.setBackendErrors(errorContent, this.errors);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }


  private getCredito(idCreditos: number) {
    this.creditosService.get(idCreditos).subscribe(
      response => {
        const credito = response.json().content;
        this.isCreditoMeses = (credito.idTipos_Creditos === TiposCreditos.MesesSinIntereses);

        switch (credito.statusCredito) {
          case EstatusCreditos.Vigente:
          case EstatusCreditos.Finalizado:
            this.isValidShowPagos = true;
            break;
          case EstatusCreditos.Borrador:
          case EstatusCreditos.Pendiente:
            this.isValidShowPagos = false;
            break;
        }

        this.isValidToAddPago = (credito.statusCredito === EstatusCreditos.Vigente);
      },
      error => {
        this.helperService.httpGlobalError(error);
        if (error.status === 400) {
          this.helperService.setBackendErrors(error.json().content, this.errors);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

toggleSubpagos(pagoId: number): void {
  this.expandedPagos[pagoId] = !this.expandedPagos[pagoId];
}
trackBySubpagoId(index: number, item: any): number {
  return item.idsubpago || item.idSubpagos || item.id || index;
}

  public showPago(event: any, pago: any) {
    this.agregarPago.showModalPago(pago.idPago);
  }

  public descargarRecibo(pago: any) {
    this.waitingResponse = true;
    let url = encodeURIComponent(window.location.href);
    this.pagosService.getReciboPago(pago.idPago, url).subscribe(
      (response) => {
        this.generarArchivo(response, "pago_" + pago.idPago);
        this.waitingResponse = false;
      },
      (error) => {
        this.helperService.httpGlobalError(error);
        if (error.status == 400) {
          this.helperService.setBackendErrors(error.json().content, this.errors);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
        this.waitingResponse = false;
      }
    );
  }

  private generarArchivo(response, filename) {
    let newBlob = new Blob([response._body], { type: 'application/pdf' });
    const data = window.URL.createObjectURL(newBlob);
    window.open(data);
    setTimeout(() => {
      window.URL.revokeObjectURL(data);
    }, 100);
  }
}



// WEBPACK FOOTER //
// ./src/app/creditos/components/tabla-pagos/tabla-pagos.component.ts